import { NgClass } from '@angular/common'
import { Component, Input } from '@angular/core'

export type NumberTypes = 'error' | 'info' | 'notice' | 'success' | 'warning'

@Component({
  selector: 'app-number',
  imports: [NgClass],
  templateUrl: './number.component.html',
})
export class NumberComponent {
  @Input() public type!: NumberTypes
  @Input() public size: 'default' | 'small' | 'large' = 'default'
  @Input() public close!: boolean
  @Input() public textColor!: string
}
